import {UNTITLED_CARD_NAME} from '../../common/types/constants'

export const cardTemplateName = (cardTemplate: {name: string}) =>
  cardTemplate.name || UNTITLED_CARD_NAME

export const cardTemplateVersionName = (name?: string | null) =>
  (name ?? '') || UNTITLED_CARD_NAME
